<template>
	<path
		id="Vector"
		d="M15.0617 1.77922C13.5394 1.86561 10.5139 2.18005 8.64611 3.32339C8.51722 3.40227 8.44417 3.54255 8.44417 3.68922V13.7967C8.44417 14.1176 8.795 14.3203 9.09083 14.1714C11.0125 13.2042 13.7917 12.9403 15.1658 12.8681C15.635 12.8434 15.9997 12.4673 15.9997 12.0164V2.632C16 2.14005 15.5733 1.75033 15.0617 1.77922ZM7.35361 3.32339C5.48611 2.18005 2.46056 1.86589 0.938333 1.77922C0.426667 1.75033 0 2.14005 0 2.632V12.0167C0 12.4678 0.364722 12.8439 0.833889 12.8684C2.20861 12.9406 4.98917 13.2048 6.91083 14.1726C7.20583 14.3212 7.55556 14.1187 7.55556 13.7987V3.68422C7.55556 3.53727 7.48278 3.40255 7.35361 3.32339Z"
		fill="#E2E2E2"
	/>
</template>
